module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async.opacity",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "opacity": true
      }
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-box margin-t20"
  }, [_c('b', {
    staticClass: "title-identification margin-b10"
  }, [_vm._v("Resumo e Confirmação do Pedido")]), _vm._v(" "), _c('div', {
    staticClass: "form-content"
  }, [(_vm.type == 'newVehicle') ? _c('div', {
    staticClass: "plan-line-purple margin-b30"
  }, [_c('p', [_vm._v("Plano Escolhido: "), _c('b', [_vm._v(" " + _vm._s(_vm.plan && _vm.plan.name))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row margin-t20"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Veículos")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _vm._l((_vm.vehicles), function(v, index) {
    return _c('div', {
      staticClass: "content-box margin-10"
    }, [_c('div', {
      staticClass: "inline plate-box"
    }, [_c('p', {
      staticClass: "cell-plate info-car"
    }, [_c('span', [_vm._v(_vm._s(v.plate))])])]), _vm._v(" "), _c('div', {
      staticClass: "inline info-car-box"
    }, [_c('p', {
      staticClass: "border-right-gray info-car block"
    }, [_c('b', [_vm._v(_vm._s(v.model.brand.name))])]), _vm._v(" "), _c('p', {
      staticClass: "model info-car block"
    }, [_c('b', {
      attrs: {
        "title": v.model.name
      }
    }, [_vm._v(_vm._s(_vm._f("firstWord")(v.model.name)))])]), _vm._v(" "), _c('p', {
      staticClass: "border-right-gray model info-car block",
      attrs: {
        "title": v.model.name
      }
    }, [_vm._v(_vm._s(_vm._f("fromSecWord")(v.model.name)))]), _vm._v(" "), _c('p', {
      staticClass: "model info-car block",
      attrs: {
        "title": v.categoryAxes.name
      }
    }, [_vm._v(_vm._s(v.categoryAxes.name))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row margin-t10"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("Valores")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), (_vm.type == 'newVehicle') ? [_c('table', {
    staticClass: "table stripped no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.vehicles.length), function(n) {
    return [_c('tr', [_c('td', [_vm._v("Adesão Move Mais - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]), _vm._v(" "), (_vm.isCaminhoParana) ? _c('tr', [_c('td', [_vm._v("Desconto - " + _vm._s(_vm.vehicles[n - 1].plate) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v("-" + _vm._s(_vm._f("cents")(_vm.newVehicleTax)))])]) : _vm._e(), _vm._v(" "), (_vm.guaranteeTax) ? _c('tr', [_c('td', [_vm._v("Caução - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.guaranteeTax)))])]) : _vm._e(), _vm._v(" "), (_vm.monthlyTax) ? _c('tr', [_c('td', [_vm._v("Mensalidade - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.monthlyTax)))])]) : _vm._e(), _vm._v(" "), (_vm.getKindPlan(_vm.planId) == 'RNTRC' && _vm.type != 'replaceTag') ? _c('tr', [_c('td', [_vm._v("Vinculação RNTRC - " + _vm._s(_vm.vehicles[n - 1].plate))]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.linkRntrcTax)))])]) : _vm._e()]
  }), _vm._v(" "), (_vm.showRecharge) ? _c('tr', [_c('td', [_vm._v("Carga Inicial")]), _vm._v(" "), _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeValueTotal)))])]) : _vm._e(), _vm._v(" "), (_vm.showRecharge) ? _c('tr', [_c('td', [_vm._v("Taxa de Recarga")]), _vm._v(" "), _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.rechargeTaxTotal)))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "70%"
    }
  }, [_vm._v("\n                        Cupom de Desconto\n                        "), _c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": "O cupom de desconto é um código promocional que você pode utilizar para abater uma parte ou a totalidade do valor de uma compra. É só colar um código promocional válido e clicar em aplicar desconto e pronto, você já vai ter o desconto aplicado na sua compra Move Mais!"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "inline pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cupom),
      expression: "cupom"
    }],
    staticClass: "inline form-control discount",
    attrs: {
      "minlength": "5",
      "maxlength": "25",
      "type": "text",
      "placeholder": "Digite o código",
      "disabled": _vm.descontoCupom != 0
    },
    domProps: {
      "value": (_vm.cupom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cupom = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cupomApplied),
      expression: "!cupomApplied"
    }],
    staticClass: "inline btn btn-primary btn-discount",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": !_vm.cupom
    },
    on: {
      "click": function($event) {
        return _vm.calculateDiscount()
      }
    }
  }, [_vm._v("\n                            Aplicar Desconto\n                          ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cupomApplied),
      expression: "cupomApplied"
    }],
    staticClass: "inline btn btn-danger btn-discount",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.removeDiscount()
      }
    }
  }, [_vm._v("\n                            Remover Desconto\n                          ")]), _vm._v(" "), (_vm.erroCupom) ? _c('div', {
    staticClass: "discount-error-msg"
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_vm._v(_vm._s(_vm.erroCupom))])]) : _vm._e()])]), _vm._v(" "), _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(-1 * _vm.descontoCupom)))])])], 2), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "bold-600"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.total)))])])])])] : _vm._e(), _vm._v(" "), (_vm.type == 'replaceTag') ? [_c('table', {
    staticClass: "table stripped no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.vehicles.length), function(n) {
    return _c('tr', [_c('td', [_vm._v("Taxa de substituição de TAG")]), _vm._v(" "), _c('td', {
      staticClass: "bold text-right"
    }, [_vm._v(_vm._s(_vm._f("cents")(_vm.replaceTax)))])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "bold-600"
  }, [_vm._v("TOTAL")]), _vm._v(" "), _c('td', {
    staticClass: "bold text-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.replaceTax)))])])])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isCaminhoParana) ? _c('div', {
    staticClass: "col-md-6 address-resume"
  }, [_c('b', [_vm._v("Endereço de retirada da TAG eletrônica")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "col-md-12 address-resume"
  }, [_c('div', {
    staticClass: "radio-box content-box",
    class: {
      'active': _vm.whereToDelivrey == 0
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whereToDelivrey),
      expression: "whereToDelivrey"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "0",
      "type": "radio",
      "name": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.whereToDelivrey, "0")
    },
    on: {
      "change": function($event) {
        _vm.whereToDelivrey = "0"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "0"
    }
  }, [_c('p', {
    staticClass: "inline"
  }, [_vm._v(_vm._s(_vm.address.zipCode.address) + ", " + _vm._s(_vm.address.number))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.neighborhood))]), _vm._v(" "), _c('p', [_vm._v("CEP " + _vm._s(_vm.address.zipCode.zipCode))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.address.zipCode.city) + " - " + _vm._s(_vm.address.zipCode.state) + " - Brasil")]), _vm._v(" "), (_vm.address.complement && _vm.address.complement.length > 0) ? _c('p', [_vm._v("Complemento - " + _vm._s(_vm.address.complement))]) : _vm._e(), _vm._v(" "), _c('small', {
    staticClass: "block"
  }, [_vm._v("Obs: Os Tags serão entregues no endereço informado.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('eventChangeAddress', true)
      }
    }
  }, [_vm._v("Alterar Endereço")])]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "radio-box content-box",
    class: {
      'active': _vm.whereToDelivrey == 61800016
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.whereToDelivrey),
      expression: "whereToDelivrey"
    }],
    staticClass: "radiobtn",
    attrs: {
      "id": "61800016",
      "type": "radio",
      "name": "radio",
      "value": "61800016"
    },
    domProps: {
      "checked": _vm._q(_vm.whereToDelivrey, "61800016")
    },
    on: {
      "change": function($event) {
        _vm.whereToDelivrey = "61800016"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "radio-label",
    attrs: {
      "for": "61800016"
    }
  }, [_c('p', [_vm._v("Retirar as TAGs na MSVIAS")]), _vm._v(" "), _c('small', {
    staticClass: "block"
  }, [_vm._v("As TAGs poderão ser retiradas após a confirmação do pagamento")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-back",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.getTolls('MS', '61800016')
      }
    }
  }, [_vm._v("Consultar praças")])]), _vm._v(" "), _c('div', {
    staticClass: "check"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 margin-t20",
    class: {
      'has-error': _vm.errors.has('terms')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "check-terms",
    attrs: {
      "id": "terms",
      "type": "checkbox",
      "name": "terms",
      "value": "1"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.errors.has('terms')) ? _c('div', {
    staticClass: "alert alert-danger alert-terms",
    attrs: {
      "role": "alert"
    }
  }, [_c('span', {
    staticClass: "help-block"
  }, [_vm._v("É necessário ler e concordar com os termos para realizar a adesão")])]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.showEntries) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showEntries = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Praças")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('h3', [_vm._v("Praças onde a TAG pode ser retirada")]), _vm._v(" "), _vm._l((_vm.entries), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(item.roadCode) + " KM " + _vm._s(item.km) + " - " + _vm._s(item.city))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.showEntries = false
      }
    }
  }, [_vm._v("Fechar")])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "hidden"
  }, [_c('th', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "hidden"
  }, [_c('th', {
    attrs: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "50%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-box"
  }, [_c('p', [_vm._v("Base de apoio operacional da Concessionária Caminhos do Paraná")]), _vm._v(" "), _c('p', [_vm._v("Rodovia 277, Km 249, 700")]), _vm._v(" "), _c('p', [_vm._v("Irati - PR")]), _vm._v(" "), _c('p', [_vm._v("Atendimento: Segunda a Sexta, das 8 às 17h.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label-terms",
    attrs: {
      "for": "terms"
    }
  }, [_vm._v("\n                Li e aceito as condições gerais de contratação do serviço\n                "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "/api/v2/archeion/downloadFileArcheion/termos-e-condicoes-gerais-movemais",
      "target": "_blank"
    }
  }, [_vm._v("Ver contrato")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-48f5beb2!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/vehicle/summary-vehicle.vue
// module id = 2119
// module chunks = 1